/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedPromoCode_user = {
    readonly tradeFirm?: {
        readonly rewards: {
            readonly currentPromoSegment: {
                readonly segmentCode: string | null;
            } | null;
        } | null;
    } | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_user">;
    readonly " $refType": "PdpSharedPromoCode_user";
};
export type PdpSharedPromoCode_user$data = PdpSharedPromoCode_user;
export type PdpSharedPromoCode_user$key = {
    readonly " $data"?: PdpSharedPromoCode_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPromoCode_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "concreteType": "currentPromoSegmentType",
                  "kind": "LinkedField",
                  "name": "currentPromoSegment",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "segmentCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradePromo_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '95082376d938ba410dee52ff07058d93';
export default node;
